/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useState, useEffect } from 'react';
// styles
import injectSheet from 'react-jss';
import styles from './emojiicon_styles';



/* ========== ~~~~~~~~~~ EMOJI ICON ~~~~~~~~~~ ========== */
const EmojiIcon = injectSheet(styles)((props) => {
    return (
        <span className={`emojiicon ${props.classes.emojiicon} isActive-${props.isActive}`} onClick={props.handleClick}>
            <img src={props.src} />
        </span>
    );
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default EmojiIcon;
